import React from "react";
import PropTypes from "prop-types";

/**
 * 
 * @param {*} param0 
 * @returns 
 * @deprecated
 * @todo remove
 */
const GMSButton = ({
  name = "",
  type = "button",
  border = "2",
  id = "",
  onClick,
  disabled = false,
  className = "button-outlined",
  ...props
}) => {
  return (
    <button
      type={type}
      className={className}
      id={id}
      disabled={disabled}
      onClick={onClick}
    >
      {name}
    </button>
  );
};

GMSButton.propTypes = {
  name: PropTypes.string.isRequired,
  type: PropTypes.oneOf(["button", "submit", "reset"]),
  className: PropTypes.string,
  onClick: PropTypes.func.isRequired,
};

export default GMSButton;
